@import '~swiper/swiper.min.css';
@import '~swiper/modules/navigation.min.css';
@import '~swiper/modules/pagination.min.css';


:host {
  display: block;
  width: 100%;
  height: 100%;
}

.container {
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;

  .top {
    &-left {
      position: absolute;
      top: 10px;
      left: 40px;
      width: calc(50% - 40px);
      z-index: 10;

      ::slotted(*) {
        display: inline-block;
      }

      ::slotted(img) {
        max-width: 27px;
        height: auto;

        @media (min-width: 768px) {
          max-width: 50px;
        }
      }
    }

    &-right {
      position: absolute;
      top: 10px;
      right: 40px;
      width: calc(50% - 40px);
      text-align: right;
      z-index: 100;

      ::slotted(*) {
        display: inline-block;
      }

      ::slotted(img) {
        max-width: 27px;
        height: auto;

        @media (min-width: 768px) {
          max-width: 50px;
        }
      }
    }
  }

  .bottom {
    &-left {
      position: absolute;
      bottom: 10px;
      left: 40px;
      width: calc(50% - 40px);
      z-index: 10;

      ::slotted(*) {
        display: inline-block;
      }

      ::slotted(img) {
        max-width: 27px;
        height: auto;

        @media (min-width: 768px) {
          max-width: 50px;
        }
      }
    }

    &-right {
      position: absolute;
      bottom: 10px;
      right: 40px;
      width: calc(50% - 40px);
      z-index: 10;
      text-align: right;

      ::slotted(*) {
        display: inline-block;
      }

      ::slotted(img) {
        max-width: 27px;
        height: auto;

        @media (min-width: 768px) {
          max-width: 50px;
        }
      }
    }
  }

  .swiper {
    width: 100%;
    height: 100%;
    max-width: 300px;
    margin-top: 10px;

    .swiper-wrapper {
      align-items: center;
      height: 70%;
    }

    @media (min-width: 540px) {
      max-width: 780px;
    }

    .swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .circle {
        position: absolute;
        top: calc(50% - 25px);
        left: calc(50% - 25px);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.7;
        width: 50px;
        height: 50px;
        border-radius: 100%;
        background-color: var(--color-nero);
        cursor: pointer;

        @include breakpointMin('sm') {
          top: calc(50% - 35px);
          left: calc(50% - 35px);
          width: 70px;
          height: 70px;
        }
      }

      .arrow-right {
        width: 0px;
        height: 0px;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 15px solid #ecf0f1;
        margin-left: 5px;

        @include breakpointMin('sm') {
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
          border-left: 20px solid #ecf0f1;
        }
      }
    }

    .swiper-slide img {
      display: block;
      width: 100%;
      height: auto;
      max-height: 60vh;
      object-fit: contain;
      cursor: pointer;
    }

    .swiper-button-next,
    .swiper-button-prev {
      display: none;

      &.show {
        display: block;
      }
    }

    .swiper-button-next::after,
    .swiper-button-prev::after {
      content: '';
    }

    .swiper-button-next.swiper-button-disabled,
    .swiper-button-prev.swiper-button-disabled {
      pointer-events: all;
    }

    &-bottom {
      position: relative;
    }

    &-pagination {
      position: relative;
      bottom: 0;
      margin-top: 15px;
      --swiper-pagination-bullet-width: 10px;
      --swiper-pagination-bullet-height: 10px;

      @media(min-width: 768px) {
        --swiper-pagination-bullet-width: 15px;
        --swiper-pagination-bullet-height: 15px;
      }

      &-bullet {
        background-color: var(--color-white);
        border: 1px solid var(--color-silver);
        opacity: 1.0;

        &-active {
          background: var(--color-livique-anthrazit);
          border: 1px solid var(--color-livique-anthrazit);
        }
      }
    }

    &-summary {
      position: relative;
      display: flex;
      justify-content: center;
      gap: 5px;
      font-size: 12px;
      color: var(--color-nero);
      margin-top: 15px;

      >div {
        cursor: pointer;
      }
    }
  }

}

.image-gallery__image-zoom-view {
  z-index: 99;
  position: absolute;
  left: calc(100% + 1.23rem);
  top: 0px;
  display: block;
  overflow: hidden;

  picture {
    position: relative;
    height: 100%;
    width: 100%;
  }

  img {
    position: relative;
  }
}

.image-gallery__image-zoom-cursor {
  display: none;
  pointer-events: none;

  @include breakpointMin('sm') {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.5);
    opacity: 1;
    cursor: pointer;
    z-index: 4000;

    &.show {
      display: block;
    }
  }
}
